var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"cups-rounds-list list-unstyled"},_vm._l((_vm.rounds),function(round){return _c('li',{key:round.id},[_c('collapse',{attrs:{"collapsed":!(round === _vm.d_closestRound),"round":round}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }